// Display coordinates beyond loaded history. These are interval projections,
// not provider bars or a forecast of future exchange sessions.
export function chartTimeSeconds(time) {
  if (typeof time === 'number') return Number.isFinite(time) ? time : null
  if (typeof time === 'string') {
    const value = Date.parse(time) / 1000
    return Number.isFinite(value) ? value : null
  }
  if (time && Number.isInteger(time.year) && Number.isInteger(time.month) && Number.isInteger(time.day)) {
    return Date.UTC(time.year, time.month - 1, time.day) / 1000
  }
  return null
}
export const TIMEFRAME_SECONDS = { '1min': 60, '2min': 120, '5min': 300, '10min': 600, '15min': 900, '30min': 1800, '65min': 3900, '1hour': 3600, '4hour': 14400, daily: 86400, weekly: 604800, monthly: 2592000 }
function edgeProjection(chart, series, side, timeframe) {
  const bars = series?.data?.() || []
  if (!bars.length) return null
  const scale = chart.timeScale(), edge = side === 'left' ? bars[0] : bars.at(-1)
  const time = chartTimeSeconds(edge.time), x = scale.timeToCoordinate(edge.time)
  const logical = scale.timeToIndex?.(edge.time) ?? (x == null ? null : scale.coordinateToLogical?.(x))
  const steps = TIMEFRAME_SECONDS[timeframe] ? [] : bars.slice(-32).map((bar, i, rows) => i ? chartTimeSeconds(bar.time) - chartTimeSeconds(rows[i - 1].time) : 0).filter(n => n > 0).sort((a, b) => a - b)
  const step = TIMEFRAME_SECONDS[timeframe] || steps[Math.floor(steps.length / 2)]
  return time != null && Number.isFinite(logical) && step > 0 ? { time, logical, step } : null
}
export function coordinateToChartTime(chart, series, x, timeframe) {
  const scale = chart?.timeScale()
  if (!scale || !Number.isFinite(x)) return null
  const native = scale.coordinateToTime?.(x)
  if (native != null) return native
  const logical = scale.coordinateToLogical?.(x)
  if (!Number.isFinite(logical)) return null
  for (const side of ['left', 'right']) {
    const edge = edgeProjection(chart, series, side, timeframe)
    if (edge && (side === 'left' ? logical < edge.logical : logical > edge.logical)) {
      return edge.time + (logical - edge.logical) * edge.step
    }
  }
  return null // Missing dates within loaded history stay missing.
}
export function chartTimeToCoordinate(chart, series, time, timeframe) {
  const scale = chart?.timeScale()
  if (!scale || time == null) return null
  const native = scale.timeToCoordinate(time)
  if (native != null) return native
  const seconds = chartTimeSeconds(time)
  if (seconds == null) return null
  for (const side of ['left', 'right']) {
    const edge = edgeProjection(chart, series, side, timeframe)
    if (edge && (side === 'left' ? seconds < edge.time : seconds > edge.time)) {
      return scale.logicalToCoordinate?.(edge.logical + (seconds - edge.time) / edge.step) ?? null
    }
  }
  return null
}
